import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CommunityDashboard from '../components/CommunityDashboard';
import { MenuIcon, XIcon } from 'lucide-react';
const CommunityPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-2322">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2323">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2324"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2325">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2326">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2327">
              <span className="sr-only" data-id="element-2328">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2329" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2330">
            <Sidebar activePage="community" data-id="element-2331" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2332">
        <Sidebar activePage="community" data-id="element-2333" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2334">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2335" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-2336">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-2337">
            <CommunityDashboard data-id="element-2338" />
          </div>
        </main>
      </div>
    </div>;
};
export default CommunityPage;